// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".caseEdit[data-v-629f9826]{width:100%;height:100%;position:fixed;top:0;left:0;z-index:3000;background-color:#fff}.caseEdit__input[data-v-629f9826]{padding:0 20px}", ""]);
// Exports
module.exports = exports;
